module.exports = __webpack_public_path__ + "static/media/offer1.63f0054c.png";